
import React from 'react';
import { History, MapPin, Map, Users, CircleCheck } from 'lucide-react';

// This file contains the data used by the Index page

// Features data with Lucide icons
export const features = [
  {
    icon: <History className="w-8 h-8" />,
    title: 'Historical Insights',
    description: 'Uncover the enchanting tales of New York City\'s most beloved cats, each with its own unique history and charm.'
  },
  {
    icon: <MapPin className="w-8 h-8" />,
    title: 'Guided Experience',
    description: 'Enjoy tours curated by a cat historian and led by our expert guides—passionate cat lovers who bring each story to life.'
  },
  {
    icon: <Map className="w-8 h-8" />,
    title: 'Engaging Itinerary',
    description: 'Visit iconic landmarks like the Brooklyn Bridge and Borough Hall, ending with a visit to a cat café to meet modern-day feline friends.'
  }
];

// Enhanced testimonial data
export const testimonials = [
  {
    quote: "As a museum curator, I'm always looking for fresh perspectives on history. This tour delivered fascinating stories I'd never encountered in my 20 years studying NYC.",
    author: "Harriet M.",
    role: "Museum Curator at NYU"
  },
  {
    quote: "I came for the cats, stayed for the incredible history. Our guide knew stories about even the smallest architectural details and connected them to fascinating feline tales.",
    author: "Clara J.",
    role: "Cat Café Owner"
  },
  {
    quote: "After taking walking tours in 30+ cities worldwide, this stands out as one of the most unique and well-researched experiences I've had.",
    author: "Evan T.",
    role: "Travel Blogger (30+ Cities)"
  },
  {
    quote: "Joining The Cats About Town tour was thrilling! Peggy Gavan led us around the beautiful, historic streets of Brooklyn Heights, telling us fascinating, mind-blowing, and adorable tales (tails?) of cat's past, as well as their relationships with the New Yorkers who loved them.",
    author: "Laurie S."
  },
  {
    quote: "Our tour in Walt Whitman Park covered incredible true stories of heroic NYC cats. The stories, from the Brooklyn Bridge to Brooklyn Heights, were astounding! Highly recommended for a fun and enlightening experience. Five paws up!",
    author: "Elizabeth M."
  },
  {
    quote: "I saw the Instagram ad and SO GLAD I BOOKED! A must-do tour in Brooklyn Heights. Informative and entertaining!",
    author: "Mark P."
  },
  {
    quote: "What a purrfect experience! Peggy Gavan led us around the beautiful, historic streets of Brooklyn Heights, telling us fascinating, mind-blowing, and adorable tales (tails?) of cat's past, as well as their relationships with the New Yorkers who loved them.",
    author: "Marie C."
  },
  {
    quote: "You don't have to be a crazy cat person (although, there's nothing wrong with that!) to enjoy this walking tour! Some places I had never visited before; some I knew of, but not the feline/other history behind.",
    author: "DeeAnne G"
  }
];

// Updated Gallery images with the new tour photos
export const galleryImages = [
  // Adding some of the newest uploaded tour photos
  { id: 58, src: "/lovable-uploads/038d14d3-cfe9-492c-8b2c-5af29e2ad3b2.png", alt: "Tour group exploring colorful street art in NYC during cat history tour" },
  { id: 59, src: "/lovable-uploads/1f2a0390-2cfa-41c8-9099-7638035b33fa.png", alt: "Tour group gathered on Freeman Alley with guide during NYC walking tour" },
  { id: 60, src: "/lovable-uploads/159b4e45-9f5c-4c86-a6ad-d1330cc338a0.png", alt: "Tour guide with headset microphone showing historical photographs to group" },
  { id: 61, src: "/lovable-uploads/f291e35d-2a74-4887-bb9d-254881f0ecf0.png", alt: "Happy tour participants posing together in front of colorful NYC storefront" },
  { id: 62, src: "/lovable-uploads/cbaa8ec6-c2a7-4bac-97df-af9d44a174e0.png", alt: "Tour guide explaining historical details to engaged group of participants" },
  { id: 63, src: "/lovable-uploads/3780dd9e-3a0a-41a7-8282-d2f3563e819a.png", alt: "Close-up of tour guide in cat-themed shirt with binder of historical illustrations" },
  
  // Previously newest uploaded tour photos
  { id: 48, src: "/lovable-uploads/453573d7-dac9-4eb3-9c79-2f694a059c64.png", alt: "Tour guide with leopard print bag showing Cats About Town branding" },
  { id: 49, src: "/lovable-uploads/3c529f86-b9e2-49c2-9d3f-12cea54b8849.png", alt: "Tour guide showing historical cat photograph to tour participants" },
  { id: 50, src: "/lovable-uploads/0cbad53f-e6df-463c-b930-a92988dfc4b1.png", alt: "Tour guide displaying historical cat illustrations and stories" },
  { id: 51, src: "/lovable-uploads/64f4e751-e378-4375-a21f-91a40d3bb565.png", alt: "Tour guide with historical cat photograph in urban setting" },
  
  { id: 40, src: "/lovable-uploads/618bc585-495c-4ede-9210-d4a1a82cc8f7.png", alt: "Tour group walking through New York City streets" },
  { id: 41, src: "/lovable-uploads/3a41ff29-c567-41dc-b249-03edc4cf969b.png", alt: "Tour guide presenting to group near a fountain" },
  { id: 42, src: "/lovable-uploads/1cde2dda-2543-47e0-8992-056e47304552.png", alt: "Tour group walking through a leafy park" },
  { id: 43, src: "/lovable-uploads/6a515d6f-4107-4e83-a757-1b74a2f75b64.png", alt: "Tour guide with tour group next to a historic clock" },
  { id: 44, src: "/lovable-uploads/feecf7cf-d050-430e-8108-d593ce0651ac.png", alt: "Tour guide with blue flag near historic building on White St" },
  
  // Previously added images
  { id: 30, src: "/lovable-uploads/e100a577-5b2e-45e7-8c5a-045a615b98ba.png", alt: "Tour guide explaining cat history to group in Brooklyn Heights" },
  { id: 31, src: "/lovable-uploads/cf69d03b-6e71-43d3-936d-5465eaa5212f.png", alt: "Tour group crossing street in Brooklyn" },
  { id: 32, src: "/lovable-uploads/1553a72d-81c5-4494-b76b-3644eac47893.png", alt: "Tour guide sharing stories with attentive group" },
  
  // Original images
  { id: 1, src: "/lovable-uploads/catsabouttowntours_1724332571_3440273418833225241_67182239447.jpg", alt: "Tour guide showing historical photos" },
  { id: 2, src: "/lovable-uploads/catsabouttowntours_1738852061_3562071727192517822_67182239447.jpg", alt: "NYC Skyline View with Tour Guide" },
  { id: 3, src: "/lovable-uploads/catsabouttowntours_1738852061_3562071727167250228_67182239447.jpg", alt: "Tour group on steps of historic building" }
];

// Updated fan photos to use the new @bodegacats photos
export const felineFanPhotos = [
  { id: 101, src: '/lovable-uploads/4cf849ae-1f20-11f0-a6d9-0242ac110002-19-hero_image.png', alt: 'Cat photo from @bodegacats' },
  { id: 102, src: '/lovable-uploads/4ccb07aa-1f20-11f0-bef4-0242ac110002-19-hero_image.png', alt: 'Cat photo from @bodegacats' },
  { id: 103, src: '/lovable-uploads/4d80b050-1f20-11f0-b47d-0242ac110002-19-hero_image.png', alt: 'Cat photo from @bodegacats' },
  { id: 104, src: '/lovable-uploads/d42afc9e-cbbc-11ef-87cd-0242ac110002-jpeg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
  { id: 105, src: '/lovable-uploads/d420ba7c-cbbc-11ef-8994-0242ac110002-jpeg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' },
  { id: 106, src: '/lovable-uploads/c7e1bbee-cbbc-11ef-bd75-0242ac110002-jpeg-hero_image.jpeg', alt: 'Cat photo from @bodegacats' }
];

// Press logos data with updated links to the articles
export const pressLogos = [
  {
    image: "https://cdn.b12.io/client_media/p2VnEghv/49ab3a42-6ebb-11ef-a2a3-0242ac110002-svg-regular_image.png",
    alt: "The Guardian",
    link: "https://www.theguardian.com/us-news/2024/sep/16/cat-walking-tour-brooklyn"
  },
  {
    image: "https://cdn.b12.io/client_media/p2VnEghv/84b8d216-746f-11ef-9907-0242ac110002-png-regular_image.png",
    alt: "NBC New York",
    link: "https://www.nbcnewyork.com/news/local/new-nyc-walking-tour-aims-to-capture-cat-lovers-and-history-buffs/5721049/"
  },
  {
    image: "https://cdn.b12.io/client_media/p2VnEghv/c1345f98-90c7-11ef-9031-0242ac110002-png-regular_image.png",
    alt: "Fodors",
    link: "https://www.fodors.com/world/north-america/usa/new-york/new-york-city/experiences/news/this-nyc-walking-tour-is-perfect-for-cat-lovers"
  },
  {
    image: "https://cdn.b12.io/client_media/p2VnEghv/b19c23fc-90e7-11ef-bd5c-0242ac110002-png-regular_image.png",
    alt: "AM New York",
    link: "https://www.amny.com/entertainment/things-to-do/ultimate-tour-new-york-cat-enthusiasts-cats-about-town-walking-tour/"
  },
  {
    image: "https://1000logos.net/wp-content/uploads/2021/05/NPR-logo.png",
    alt: "NPR",
    link: "https://www.npr.org/2025/04/24/nx-s1-5339780/bodega-cats"
  },
  {
    image: "https://upload.wikimedia.org/wikipedia/en/7/74/1010_WINS_92-3_New_York_2022.png",
    alt: "1010 WINS",
    link: "https://www.audacy.com/1010wins/news/local/nyc-cat-history-walking-tour-delights-feline-fans"
  },
  {
    image: "https://cdn.b12.io/client_media/p2VnEghv/02f60512-c48a-11ef-8de4-0242ac110002-png-regular_image.png",
    alt: "People Magazine",
    link: "https://people.com/bodega-cats-of-new-york-local-historian-offer-cat-centric-tours-of-new-york-city-exclusive-8762208"
  },
  {
    image: "https://upload.wikimedia.org/wikipedia/commons/8/84/EFE_logo.svg",
    alt: "EFE",
    link: "https://efe.com/mundo/2024-09-05/nueva-york-contada-por-gatos/"
  },
  {
    image: "https://www.purabrasa.com/wp-content/uploads/2024/07/time-out-logo.jpg",
    alt: "Time Out New York",
    link: "https://www.timeout.com/newyork/news/let-me-tell-youthese-weird-walking-tours-are-the-best-way-to-explore-nyc-051525"
  },
  {
    image: "https://brandlogos.net/wp-content/uploads/2024/04/new_york_post-logo_brandlogos.net_7y8q7.png",
    alt: "New York Post",
    link: "https://cdn.b12.io/client_media/p2VnEghv/c4ad67f8-95fb-11ef-89c2-0242ac110002-23A.HighEnd.pdf"
  },
  {
    image: "https://cdn.b12.io/client_media/p2VnEghv/0a3c9cb0-c8cb-11ef-b552-0242ac110002-png-regular_image.png",
    alt: "W42ST",
    link: "https://w42st.com/post/how-child-free-cat-lady-jenny-became-a-new-york-city-tour-guide/"
  },
  {
    image: "/lovable-uploads/secretnyc-logo.png",
    alt: "SecretNYC",
    link: "https://secretnyc.co/"
  }
];

// Features for the "Why Our Tours Stand Out" section
export const tourFeatures = [
  {
    icon: <History className="w-8 h-8" />,
    title: 'Authentic Historical Research',
    description: 'Every story is brought to life by historian Peggy Gavan\'s meticulous research.'
  },
  {
    icon: <Users className="w-8 h-8" />,
    title: 'Small, Intimate Groups',
    description: 'Limited to small groups, ensuring personal attention and a chance to connect with fellow cat lovers.'
  },
  {
    icon: <Map className="w-8 h-8" />,
    title: 'NYC\'s Only Cat History Tour',
    description: 'Experience a one-of-a-kind journey through the city\'s feline past.'
  },
  {
    icon: <CircleCheck className="w-8 h-8" />,
    title: 'Memorable Connections',
    description: 'Discover stories that spark joy and deepen your love for NYC\'s history.'
  }
];

// Adding seasonal relevance text
export const seasonalContent = {
  heading: "Summer 2025 tours booking now",
  subheading: "The best season to discover NYC's outdoor cat history",
  image: "/lovable-uploads/60a3dca8-f81d-4384-bef9-fcdebdc99d57.png"
};

// Emotional elements to add to tour pages
export const emotionalElements = {
  memories: "Create memories that last longer than photos. Two hours with us becomes stories you'll tell for years.",
  smallGroup: "Limited to 12 guests for personal attention and questions",
  localSecret: "Local's Secret"
};
